'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeOutDownBig = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, _utils.translate3d)(0, '2000px', 0)
  }
};
exports.default = fadeOutDownBig;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-out-down-big.js
// module id = 218
// module chunks = 54990529738226 257444579329143